import { QueryClient } from '@tanstack/react-query';

import { queryClientConfig } from './api/queryClientConfig';

export const queryClient = new QueryClient(queryClientConfig);
